export default {"src":"/_next/static/media/homepage-linkedin-footer-icon-desktop.f201137a.svg","height":35,"width":36,"blurWidth":0,"blurHeight":0};